<template>
  <div>
    <b-container fluid class="p-0">
      <SlicesBlock v-if="customHomePage" class="home-padding" :slices="slices" />
      <Home v-else />
    </b-container>
  </div>
</template>

<script>
import Home from '@/components/Home';
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';

export default {
  name: 'Index',
  components: {
    Home,
    SlicesBlock
  },
  async asyncData({ $prismic, store, redirect, $cookies, localePath }) {
    try {
      const strategy = $cookies.get('vx.strategy');
      const token = $cookies.get(`vx.token.${strategy}`);
      if (strategy && token) {
        return redirect(localePath('/home'));
      }

      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      await store.dispatch('config/SEASONAL_STATUS');
      const isSeasonalActive = store.getters['config/isSeasonalActive'];
      const homeUid = isSeasonalActive ? 'home-seasonal' : 'home';

      const result = await $prismic.api.getByUID('post', homeUid, { lang: language.id });

      if (!result) {
        return {
          customHomePage: false
        };
      }

      return {
        slices: result.data.body,
        customHomePage: true
      };
    } catch (e) {
      return {
        customHomePage: false
      };
    }
  },
  head() {
    return {
      meta: [
        {
          hid: 'google-site-verification',
          name: 'google-site-verification',
          content: 'eDoiZhgQY6m_dOV53MSCpfR-ne8PniIp5vxQme7zTpo'
        }
      ],
      link: [
        {
          rel: 'prefetch',
          href: 'https://cdn.vexels.com/img/designhome.png?fmt=webp'
        },
        {
          rel: 'prefetch',
          href: 'https://cdn.vexels.com/img/merchhome.png?fmt=webp'
        }
      ]
    };
  },
  jsonld() {
    const locales = this.$store.$i18n.locales;
    const local = this.$store.$i18n.locale;
    let { domain } = locales.find((item) => local.startsWith(item.iso) == true);
    return [
      {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: 'Vexels',
        url: `https://${domain}`,
        logo: 'https://cdn.vexels.com/img/logo-variants/default-logo-variant.svg',
        contactPoint: [
          {
            '@type': 'ContactPoint',
            telephone: '+1-650-452-6034',
            contactType: 'customer service',
            availableLanguage: ['English', 'Spanish']
          }
        ],
        sameAs: [
          'https://www.facebook.com/vexelsgraphics',
          'https://www.instagram.com/vexelsgraphics/',
          'https://www.pinterest.com/vexels/',
          'https://www.linkedin.com/company/vexels',
          'https://www.youtube.com/channel/UCRDRPDSaNcD_x8p_sxGqToA'
        ]
      },
      {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        name: 'Vexels',
        url: `https://${domain}`,
        potentialAction: [
          {
            '@type': 'SearchAction',
            target: `https://${domain}/graphics/{search_term_string}`,
            'query-input': 'required name=search_term_string'
          }
        ]
      }
    ];
  }
};
</script>
